
import { readAppConfigs, readUserProfile } from "@/store/main/getters";
import { dispAuthFetch,
  
} from "@/store/mlm/actions";
import { dispatchUpdateUserInfo } from "@/store/main/actions";

import { Component, Vue } from "vue-property-decorator";
import ListPagination from "@/components/Main/ListPagination.vue";
import ListTeamTree from "@/components/Main/Team/ListTeamTree.vue";
import UiLoader from "@/components/Main/Ui/UiLoader.vue";
import {
  dispatchGetAllConfigs,
  dispatchGetUserProfile,
} from "@/store/main/actions";
import { IPackageStatisticsResponse } from "@/interfaces/mlm";
import EthicsCodexModal from "@/components/Main/EthicsCodexModal.vue";


@Component({
  components: {
    UiLoader,
    EthicsCodexModal,
    ListPagination,
    ListTeamTree,
  },
})
export default class Team extends Vue {
  // public showPackagePaymentModal: boolean = false;
  // public selectedPackage: IPackage | null = null;
  public selectedUser: number | null = null;
  public activeTab: string = "list_tree";
  public side: string = "S";
  public referralLink: string = "";
  public structureList: any = [];
  public structureSearchKeyword: string = "";
  public structureSearchResult: any = [];
  public showECodexModal: boolean = false;
  public has_token_user_package: boolean = false
  // public virtual_nodes = []

  public page: number = 1;
  public isLoadPackagesStatistics = false;

  // --- bitbook 16.03.2026 --- //
  public isLoading = false;


  public handleCloseECodexModal(result) {
     this.showECodexModal = false
   }

  public async mounted() {
    this.isLoading = true;
  //  dispatchGetAllConfigs(this.$store);
  
    await dispatchGetUserProfile(this.$store);
    if (this.userProfile) {
      if(this.userProfile.referral_link){     
        this.referralLink = this.userProfile.referral_link
      }
    }
    
    this.isLoading = false;
  }

  public async handleTokenServiceIntegration() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/token_service_integration/token_package/info/",
      init: {
        method: "POST",
        body: {},
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      this.has_token_user_package = (await invoiceResp.json())?.has_token_user_package;
    }
  }


  public async handleUpdateEthicsStatus() {
  if(this.userProfile?.role === 'RESIDENT' || this.userProfile?.role === 'RESIDENT_LIMITED' ){
    this.showECodexModal = true;
  } else {
    await dispatchUpdateUserInfo(this.$store, { code_of_etics_status: "chk" });
    await dispatchGetUserProfile(this.$store)
  }
   
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
